var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-big-container"},[_c('div',{staticClass:"loading-wrapper"},[(_vm.loadingTheme === 1)?_c('div',{staticClass:"loading-big"}):_vm._e(),(_vm.loadingTheme === 2)?_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_c('div',{staticClass:"double-bounce2"})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }